import { render, staticRenderFns } from "./uplodeInput2.vue?vue&type=template&id=7bf6ea70&scoped=true&"
import script from "./uplodeInput2.vue?vue&type=script&lang=js&"
export * from "./uplodeInput2.vue?vue&type=script&lang=js&"
import style0 from "./uplodeInput2.vue?vue&type=style&index=0&id=7bf6ea70&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf6ea70",
  null
  
)

export default component.exports